<template>
  <v-app>
    <div v-show="checkSessionTokenExists">
      <progressDialog v-bind:loadingContent="loadingContent" />
      <v-main>
        <bottomNav v-show="loaded" />
        <router-view/>
      </v-main>
    </div>
  </v-app>
</template>

<script>
import bottomNav from '@/components/bottom-nav/index.vue';
import progressDialog from '@/components/progress-dialog/progressDialog.vue';
import Store from './service/Store';
import DrivesService from './service/DrivesService';
import { effectiveBearerTokenValue } from './service/authStrategy';

export default {
  name: 'App',

  components: {
    bottomNav,
    progressDialog,
  },

  data: () => ({
    loadingContent: false,
    checkSessionTokenExists: false,
    loaded: false,
  }),

  methods: {
    setTheme() {
      let themeParam = this.$route.query.theme;
      if (!themeParam) {
        const theme = Store.getTheme();
        themeParam = theme || 'light';
      }
      Store.saveTheme(themeParam);
      this.$themes.applyTheme(themeParam);
    },
    applyValidatedSession(response, fallbackToken = null) {
      if (!response || !response.data) {
        return false;
      }

      const responseToken = effectiveBearerTokenValue(response.data.token);
      if (responseToken) {
        Store.saveToken(responseToken);
      } else if (fallbackToken) {
        Store.saveToken(fallbackToken);
      } else {
        Store.clearToken();
      }

      return true;
    },
    async tryLoadTokenFull(token = null, fallbackToken = null) {
      try {
        const response = await DrivesService.loadTokenFull(token);
        return this.applyValidatedSession(response, fallbackToken);
      } catch {
        return false;
      }
    },
    async initializeSession() {
      try {
        const queryToken = effectiveBearerTokenValue(this.$route.query.token);
        const storedToken = effectiveBearerTokenValue(Store.getToken());

        if (queryToken) {
          Store.saveToken(queryToken);
        }

        let sessionExists = queryToken
          ? await this.tryLoadTokenFull(queryToken, queryToken)
          : false;

        if (!sessionExists) {
          sessionExists = await this.tryLoadTokenFull(null, storedToken || null);
        }

        if (!sessionExists && storedToken) {
          sessionExists = await this.tryLoadTokenFull(storedToken, storedToken);
        }

        if (!sessionExists) {
          Store.clearToken();
        }

        this.checkSessionTokenExists = sessionExists;
      } finally {
        this.loaded = true;
      }
    },
  },

  created() {
    this.setTheme();
    this.initializeSession();
  },
};
</script>
<style lang="scss">
@import 'public/styles/vuetify-variables.scss';
</style>
